import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AuthContext from "../Context/AuthProvider";
import { getFacilityUsers } from "../API/UsersApi";
import { getClinicalServices } from "../API/FacilitySettingsApi";
import {
  DurationOptions,
  FrequencyOptions,
  PlanTypes,
  PaymentModes,
  VisitTypes,
} from "../Utility/Constants";
import SearchSelectPatient1 from "../Patients/SearchSelectPatient1";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { convertToUTC } from "../Utility/DateTimeUtility";
import { createNewPlan } from "../API/PlansApi";
import { toBeChecked } from "@testing-library/jest-dom/matchers";
import { showLoadingImage } from "../Utility/Utility";
import { useSnackbar } from "../Utility/UserMessageContext";
import MenuBar from "../common/MenuBar";
import "../common/styles/CommonStyles.css"; // Import your custom styles
import GenericTextField from "../common/GenericTextField";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import GenericDatePicker from "../common/GenericDatePicker";
import GenericDropDown from "../common/GenericDropDown";
import CloseIcon from "@mui/icons-material/Close";
import GenericActionButton from "../common/GenericActionButton";
import { Add } from "@mui/icons-material";
import { convertUTCToTimeZoneDateString } from "../Utility/DateTimeUtility";

const NewPlan = ({ newPlanTempId, planType, closeTab }) => {
  const { showSnackbar } = useSnackbar();
  const [selectedPatient, setSelectedPatient] = useState();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const { auth } = useContext(AuthContext);
  const [patientNotes, setPatientNotes] = useState();
  const [billNotes, setbillNotes] = useState();
  const [availableServices, setAvailableServices] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [selectedPhysicianId, setSelectedPhysicianId] = useState();
  const [selectedService, setSelectedService] = useState("");
  const [selectedPhysician, setSelectedPhysician] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [scheduledFrom, setScheduledFrom] = useState();
  const [scheduledTo, setScheduledTo] = useState();
  const [scheduledStartDateTime, setScheduledStartDateTime] = useState();
  const [scheduledEndDateTime, setScheduledEndDateTime] = useState();
  const [addingPlan, setAddingPlan] = useState(false);
  const [dataRestored, setDataRestored] = useState(false);
  const [planName, setPlanName] = useState("");
  const [session, setsession] = useState([]);
  const [sessionStartDate, setSessionStartDate] = useState();
  const [numberOfSessions, setNumberOfSessions] = useState("");
  const [sessionFrequency, setSessionFrequency] = useState("");
  const [scheduleSameTime, setScheduleSameTime] = useState(false);

  const [referredBy, setReferredBy] = useState("");
  const [sessionSelectedTime, setSessionSelectedTime] = useState(null);
  const [planVisitType, setplanVisitType] = useState("");
  const [shouldGenerateBill, setShouldGenerateBill] = useState(false);
  const [discountInPercentage, setDiscountInPercentage] = useState(0);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [totalBilledAmount, settotalBilledAmount] = useState(0);
  const [totalAmount, settotalAmount] = useState(0);

  useEffect(() => {
    const getPhysicians = async () => {
      var result = await getFacilityUsers(auth, {
        facilityId: auth.selectedFacility.id,
        roles: ["Physician"],
      });
      if (result?.isSuccess) {
        setAvailablePhysicians(result?.data);
      }
    };

    // const restoreData = () => {
    //   const savedNewPlan = localStorage.getItem(newPlanTempId);

    //   if (savedNewPlan) {
    //     const savedNewPlanJSON = JSON.parse(savedNewPlan);
    //     if (savedNewPlanJSON) {
    //       setSelectedPatient(savedNewPlanJSON.selectedPatient);
    //       setSelectedPhysicianId(savedNewPlanJSON.selectedPhysicianId);
    //       setPatientNotes(savedNewPlanJSON.patientNotes);
    //     }
    //   }
    //   setDataRestored(true);
    // };

    //setDataRestored(false);

    getPhysicians();
    // restoreData();
  }, [auth, newPlanTempId]);

  useEffect(() => {
    const setClinicalServices = async () => {
      const filters = {
        facilityId: auth.selectedFacility.id,
        visitType: planVisitType,
      };
      if (!planVisitType) return;
      var result = await getClinicalServices(auth, filters);
      if (result.isSuccess) {
        // console.log(result?.data);
        setAvailableServices(result?.data);
      } else {
        showSnackbar(
          "Error occurred while fetching clinical services.",
          "error"
        );
      }
    };
    setClinicalServices();
  }, [planVisitType]);

  useEffect(() => {
    if (session && session.length > 0) {
      const total = session.reduce(
        (acc, curr) => acc + (parseFloat(curr.billAmount) || 0),
        0
      );
      settotalBilledAmount(total);
    }
    if (session && session.length > 0) {
      let totalAmount = 0;
      session.map((ses) => {
        totalAmount = ses.service.fees + totalAmount;
      });
      settotalAmount(totalAmount);
    }
  }, [session]); // Runs whenever session changes3

  const onScheduledDateTimeChange = (choosenDate, fromTime, toTime) => {
    if (choosenDate && fromTime && toTime) {
      const startDateTime = dayjs(choosenDate)
        .set("hour", fromTime.hour())
        .set("minute", fromTime.minute());
      const endDateTime = dayjs(choosenDate)
        .set("hour", toTime.hour())
        .set("minute", toTime.minute());
      if (!endDateTime.isAfter(startDateTime)) {
        showSnackbar("End date time should be after start date time.", "error");
        return;
      }
      setScheduledStartDateTime(startDateTime);
      setScheduledEndDateTime(endDateTime);
    }
  };
  const getStartDateTime = (choosenDate, fromTime) => {
    if (choosenDate && fromTime) {
      const startDateTime = dayjs(choosenDate)
        .set("hour", fromTime.hour())
        .set("minute", fromTime.minute());

      return startDateTime;
    }

    return null; // If inputs are invalid
  };

  const getEndDateTime = (choosenDate, fromTime, durationInMinutes) => {
    if (!choosenDate || !fromTime || typeof durationInMinutes !== "number") {
      return null;
    }
    const startDateTime = dayjs(choosenDate)
      .set("hour", fromTime.hour())
      .set("minute", fromTime.minute());

    const endDateTime = startDateTime.add(durationInMinutes, "minute");
    return endDateTime;
  };

  let visitForApiRequest = session.map((data) => ({
    patientId: selectedPatient.id,
    physicianId: data.assignedTo.id,
    scheduledStartDateTime: getStartDateTime(
      data.date,
      dayjs(data.time, "HH:mm")
    ),
    scheduledEndDateTime: getEndDateTime(
      data.date,
      dayjs(data.time, "HH:mm"),
      data.duration
    ),
    clinicalServiceId: data.service.id,
    facilityId: auth.selectedFacility.id, // once verify by sir jii
    visitType: planVisitType,
    discountInPercentage: parseInt(data.discount, 10),

    //we have to pass this same value in all visit and this value is already pass in api
    notes: patientNotes,
    referredBy: referredBy,
    advanceAmount: parseInt(advanceAmount, 10),
    paymentMode: paymentMode,
  }));

  const addPlan = async () => {
    setAddingPlan(true);
    const result = await createNewPlan(auth, {
      name: planName,
      paidAmount: parseInt(advanceAmount, 10),
      paymentMode: paymentMode,
      physicianId: selectedPhysicianId,
      patientId: selectedPatient.id,
      initialNotes: patientNotes,
      facilityId: auth.selectedFacility.id,
      referredBy: referredBy,
      billingSummary:billNotes,
      clinicalSummary:patientNotes,
      visits: visitForApiRequest,
    });

    if (result.isSuccess) {
      showSnackbar("Plan created successfully.", "success");
      closeTab(newPlanTempId);
    } else {
      showSnackbar("Error occurred while creating the plan.", "error");
    }

    setAddingPlan(false);
  };

  const generateSessions = (
    startDate,
    sessionSelectedTime,
    numSessions,
    frequency,
    selectedService,
    discountInPercentage,
    selectedPhysician
  ) => {
    const sessions = [];
    let currentDate = dayjs(startDate);

    let amountAfterDiscount =
      selectedService.fees * (1 - discountInPercentage / 100);

    for (let i = 0; i < parseInt(numSessions); i++) {
      sessions.push({
        serialNo: session.length + i + 1,
        date: currentDate.format("YYYY-MM-DD"),
        time: sessionSelectedTime,
        duration: selectedService.durationInMins,
        service: selectedService,
        assignedTo: selectedPhysician,
        discount: discountInPercentage,
        billAmount: amountAfterDiscount,
      });

      // Calculate next date based on frequency
      switch (frequency) {
        case "daily":
          currentDate = currentDate.add(1, "day");
          break;
        case "alternate":
          currentDate = currentDate.add(2, "day");
          break;
        case "weekly":
          currentDate = currentDate.add(1, "week");
          break;
        case "biweekly":
          currentDate = currentDate.add(2, "week");
          break;
        case "monthly":
          currentDate = currentDate.add(1, "month");
          break;
        default:
          currentDate = currentDate.add(1, "day");
      }
    }

    return sessions;
  };
  return (
    <Grid2 container>
      <Grid2 container size={12}>
        {/* Save Plan Action */}
        <Grid2
          container
          size={12}
          sx={{ justifyContent: "start", alignItems: "center" }}
        >
          <Grid2 size={12}>
            {addingPlan && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(216, 214, 214, 0.4)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1301,
                }}
              >
                {showLoadingImage()}
              </div>
            )}

            <MenuBar
              showSave={true}
              onSave={() => addPlan()}
              saveLabel="Save Plan"
              saveTooltip="New Plan"
              disabled={
                addingPlan ||
                !selectedPatient ||
                !selectedPhysicianId ||
                !selectedServiceId ||
                session.length === 0
              }
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        size={12}
        container
        spacing={2}
        sx={{
          paddingX: 2,
          maxHeight: "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        <Card className="outerCard" variant="outlined">
          <Grid2 size={12} container spacing={1} sx={{ padding: 1 }}>
            <Grid2
              size={4}
              container
              spacing={1}
              sx={{
                padding: 1,
                alignItems: "start",
                border: "2px solid rgb(215, 217, 220)",
                borderRadius: 2,
              }}
            >
              {/* Plan Name Input */}
              <Grid2 size={{ xs: 12, md: 12 }}>
                <GenericTextField
                  label="Plan Name"
                  value={planName}
                  onChange={(e) => setPlanName(e.target.value)}
                  disabled={addingPlan}
                  inputSlotProps={{
                    inputLabel: { shrink: true },
                  }}
                  fullWidth
                  size="small"
                  placeholder="Enter Plan Name"
                  helperText=""
                />
              </Grid2>

              <Grid2 container size={12} spacing={1}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                   <LocalizationProvider dateAdapter={AdapterDayjs}>
    <GenericDatePicker
      label="Session Start Date"
      value={sessionStartDate}
      onChange={(value) => setSessionStartDate(value)}
      // minDate={dayjs(new Date())}
      disabled={addingPlan}
      returnDayjsObject={true}  // Add this
    />
  </LocalizationProvider>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <TextField
                    label="Select Time"
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="time"
                    margin="dense"
                    // InputLabelProps={{ shrink: false }}
                    value={sessionSelectedTime}
                    onChange={(e) => {
                      setSessionSelectedTime(e.target.value);
                    }}
                    sx={{
                      background: "white",
                      borderRadius: 1,
                    }}
                  />
                </Grid2>
              </Grid2>

              <Grid2 container size={12} spacing={1}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <GenericTextField
                    label="Number of Sessions"
                    value={numberOfSessions}
                    helperText=""
                    onChange={(e) => setNumberOfSessions(e.target.value)}
                    type="number"
                    inputProps={{ min: 1, max: 100 }}
                    disabled={addingPlan}
                    size="small"
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, md: 6 }}>
                  <GenericDropDown
                    label="Frequency"
                    value={sessionFrequency}
                    onChange={(e) => setSessionFrequency(e.target.value)}
                    options={FrequencyOptions}
                    disabled={addingPlan}
                    size="small"
                  />
                </Grid2>
              </Grid2>

              <Grid2 container size={12} spacing={1}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <GenericTextField
                    label="Discount (%)"
                    fullWidth
                    margin="dense"
                    type="number"
                    size="small"
                    value={discountInPercentage}
                    onChange={(e) => setDiscountInPercentage(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    disabled={addingPlan}
                    placeholder="Enter discount percentage"
                    inputProps={{ min: 1, max: 100 }}
                    helperText=""
                  />
                </Grid2>
                <Grid2 container size={{ xs: 12, md: 6 }}>
                  <GenericTextField
                    label="Referred By"
                    value={referredBy}
                    onChange={(e) => setReferredBy(e.target.value)}
                    disabled={addingPlan}
                    inputSlotProps={{
                      inputLabel: { shrink: true },
                    }}
                    fullWidth
                    size="small"
                    placeholder="Enter referring doctor / Clinic name"
                    helperText=""
                  />
                </Grid2>
              </Grid2>
            </Grid2>

            <Grid2
              size={4}
              container
              spacing={1}
              sx={{
                padding: 1,
                border: "2px solid rgb(215, 217, 220)",
                borderRadius: 2,
              }}
            >
              <Grid2 container size={12} spacing={1} alignItems="start">
                <Grid2 size={{ xs: 12, md: 12 }} item>
                  <SearchSelectPatient1
                    setSelectedPatient={setSelectedPatient}
                    disabled={addingPlan}
                  />
                </Grid2>
              </Grid2>

              <Grid2 container size={12} spacing={1} alignItems="start">
                <Grid2 container size={{ xs: 12, md: 12 }}>
                  <GenericDropDown
                    label="Physician"
                    value={selectedPhysicianId || ""}
                    onChange={(e) => {
                      setSelectedPhysicianId(e.target.value);
                      setSelectedPhysician(
                        availablePhysicians.find((p) => p.id === e.target.value)
                      );
                    }}
                    options={
                      availablePhysicians?.map((p) => ({
                        value: p.id,
                        label: `${p.salutation} ${p.firstName} ${p.lastName}, ${p.suffix}`,
                      })) || []
                    }
                    required={false}
                    error={false}
                    name="physician"
                    size="small"
                    disabled={addingPlan}
                  />
                </Grid2>
              </Grid2>

              <Grid2 container size={12} spacing={1} alignItems="start">
                <Grid2 size={{ xs: 12, md: 12 }}>
                  <GenericDropDown
                    label="Visit Type"
                    value={planVisitType}
                    onChange={(e) => setplanVisitType(e.target.value)}
                    options={["Home", "OPD"]}
                    disabled={addingPlan}
                    size="small"
                  />
                </Grid2>
                <Grid2 container size={{ xs: 12, md: 12 }}>
                  <GenericDropDown
                    label="Primary Service"
                    value={selectedServiceId || ""}
                    onChange={(e) => {
                      setSelectedServiceId(e.target.value);
                      setSelectedService(
                        availableServices.find((s) => s.id === e.target.value)
                      );
                    }}
                    options={
                      availableServices?.map((s) => ({
                        value: s.id,
                        label: `${s.name}, Fees Rs. ${s.fees}, Duration ${s.durationInMins} Mins`,
                      })) || []
                    }
                    required={false}
                    error={false}
                    size="small"
                    name="primaryService"
                    disabled={addingPlan}
                  />
                </Grid2>
              </Grid2>

              <Grid2 container size={12} spacing={1} alignItems="start"></Grid2>
            </Grid2>

            <Grid2
              size={4}
              container
              spacing={1}
              sx={{
                padding: 1,
                border: "2px solid rgb(215, 217, 220)",
                borderRadius: 2,
              }}
            >
              <Grid2 container size={12} spacing={1} alignItems={"start"}>
                <Grid2 container size={{ xs: 12, md: 12 }}>
                  <GenericTextField
                    label="Patient Summary"
                    value={patientNotes}
                    multiline
                    minRows={4}
                    maxRows={5}
                    disabled={addingPlan}
                    size="small"
                    onChange={(e) => {
                      setPatientNotes(e.target.value);
                    }}
                    inputSlotProps={{
                      inputLabel: { shrink: true },
                    }}
                    helperText=""
                  />
                </Grid2>
                <Grid2 container size={{ xs: 12, md: 12 }}>
                  <GenericTextField
                    label="Bill Summary"
                    value={billNotes}
                    multiline
                    minRows={4}
                    maxRows={5}
                    disabled={addingPlan}
                    size="small"
                    onChange={(e) => {
                      setbillNotes(e.target.value);
                    }}
                    inputSlotProps={{
                      inputLabel: { shrink: true },
                    }}
                    helperText=""
                  />
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>

          <Grid2
            size={12}
            container
            spacing={2}
            sx={{
              padding: 2,
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Tooltip title="Create Visits" arrow>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={() => {
                  const newSessions = generateSessions(
                    sessionStartDate,
                    sessionSelectedTime,
                    numberOfSessions,
                    sessionFrequency,
                    selectedService,
                    discountInPercentage,
                    selectedPhysician
                  );
                  setsession(newSessions);
                }}
                disabled={
                  addingPlan ||
                  !sessionStartDate ||
                  !sessionSelectedTime ||
                  !numberOfSessions ||
                  !sessionFrequency ||
                  !selectedService ||
                  !selectedPhysician ||
                  !selectedPatient
                }
                sx={{ textTransform: "none" }}
                startIcon={<Add />}
              >
                Create Visits
              </Button>
            </Tooltip>
            <Tooltip title="Clear Visits" arrow>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={() => {
                  setsession([]);
                  settotalAmount(0);
                  settotalBilledAmount(0);
                }}
                disabled={session.length === 0}
                sx={{ textTransform: "none" }}
              >
                Clear Visits
              </Button>
            </Tooltip>
          </Grid2>

          <Grid2
            container
            size={12}
            spacing={1}
            sx={{
              padding: 1,
              border: "2px solid rgb(215, 217, 220)",
              borderRadius: 2,
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 300,
                overflowY: "auto",
              }}
              className="outerCard"
            >
              <Table sx={{ minWidth: 1050 }} size="small" stickyHeader>
             <TableHead>
  <TableRow
    sx={{
      background:
        "linear-gradient(90deg, #e3f2fd 0%, #f5f7fa 100%)",
    }}
  >
    <TableCell
      align="center"
      sx={{ fontWeight: "bold", width: "3%" }}
    >
      #
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", width: "180px", minWidth: "180px" }}> {/* Fixed width */}
      Date
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", width: "120px", minWidth: "120px" }}> {/* Fixed width */}
      Time
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", width: "100px", minWidth: "100px" }}>
      Duration
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", minWidth: "200px" }}>
     Primary Service
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", minWidth: "200px" }}>
      Assigned To
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", width: "100px", minWidth: "100px" }}>
      Discount
    </TableCell>
    <TableCell sx={{ fontWeight: "bold", width: "120px", minWidth: "120px" }}>
      Bill Amount
    </TableCell>
    <TableCell
      align="center"
      sx={{ fontWeight: "bold", width: "60px" }}
    ></TableCell>
  </TableRow>
</TableHead>
                <TableBody>
                  {session &&
                    session.map((med) => (
                      <TableRow key={med.serialNo} hover>
                        <TableCell align="center">{med.serialNo}</TableCell>
             <TableCell>
  <GenericDatePicker
    label=""
    value={med.date || ""}
    onChange={(formattedDate) => {
      const copied = [...session];
      const idx = copied.findIndex(
        (m) => m.serialNo === med.serialNo
      );
      copied[idx].date = formattedDate;
      setsession(copied);
    }}
    displayFormat="DD-MMM-YYYY"  // Add this - 3 letter month
    outputFormat="YYYY-MM-DD"    // Add this - for backend
    slotProps={{
      textField: {
        size: "small",
        variant: "outlined",
        fullWidth: true,
        margin: "none",
        placeholder: "DD-MMM-YYYY",  // Add this
        InputProps: {
          placeholder: "DD-MMM-YYYY",  // Add this too
        },
        sx: {
          background: "#fff",
          borderRadius: 1,
          minWidth: "160px",
          '& .MuiOutlinedInput-root': {
            height: '40px',
            fontSize: '0.875rem',
          }
        }
      }
    }}
  />
</TableCell>
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type="time"
                            InputLabelProps={{ shrink: true }}
                            value={med.time || ""}
                            onChange={(e) => {
                              const copied = [...session];
                              const idx = copied.findIndex(
                                (m) => m.serialNo === med.serialNo
                              );
                              copied[idx].time = e.target.value;
                              setsession(copied);
                            }}
                            sx={{
                              background: "#fff",
                              borderRadius: 1,
                            }}
                            placeholder="Select Time"
                          />
                        </TableCell>

                        <TableCell>
                          {/* duration (Free Text) */}
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type="number"
                            value={med.duration || ""}
                            onChange={(e) => {
                              const copied = [...session];
                              const idx = copied.findIndex(
                                (m) => m.serialNo === med.serialNo
                              );
                              copied[idx].duration = e.target.value;
                              setsession(copied);
                            }}
                            placeholder="Duration in Min"
                            sx={{
                              background: "#fff",
                              borderRadius: 1,
                            }}
                          />
                        </TableCell>

                        <TableCell>
                          <GenericDropDown
                            value={med.service.id || ""}
                            onChange={(e) => {
                              const selectedServiceId = e.target.value;
                              const selectedService = availableServices.find(
                                (s) => s.id === selectedServiceId
                              );
                              const copied = [...session];
                              const idx = copied.findIndex(
                                (m) => m.serialNo === med.serialNo
                              );
                              copied[idx].service = selectedService;
                              copied[idx].duration =
                                selectedService.durationInMins;
                              copied[idx].billAmount =
                                selectedService.fees *
                                (1 - copied[idx].discount / 100);

                              setsession(copied);
                            }}
                            options={
                              availableServices?.map((s) => ({
                                value: s.id,
                                label: `${s.name}, Fees Rs. ${s.fees}, Duration ${s.durationInMins} Mins`,
                              })) || []
                            }
                            name="service"
                            size="small"
                            disabled={addingPlan}
                            fullWidth
                            sx={{ width: "175px" }}
                          />
                        </TableCell>
                        <TableCell>
                          <GenericDropDown
                            value={med.assignedTo.id || ""}
                            onChange={(e) => {
                              const selectedPhysicianId = e.target.value;
                              const selectedPhysician =
                                availablePhysicians.find(
                                  (s) => s.id === selectedPhysicianId
                                );
                              const updatedplan = session.map((m) =>
                                m.serialNo === med.serialNo
                                  ? { ...m, assignedTo: selectedPhysician }
                                  : m
                              );
                              setsession(updatedplan);
                            }}
                            options={
                              availablePhysicians?.map((p) => ({
                                value: p.id,
                                label: `${p.salutation} ${p.firstName} ${p.lastName}, ${p.suffix}`,
                              })) || []
                            }
                            name="assignedTo"
                            size="small"
                            disabled={addingPlan}
                            fullWidth
                            sx={{ width: "175px" }}
                          />
                        </TableCell>
                        {/* discount */}
                        <TableCell>
                          {/* discount (Free Text) */}
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type="number"
                            inputProps={{ min: 0, max: 100 }}
                            value={med.discount || ""}
                            onChange={(e) => {
                              const copied = [...session];
                              const idx = copied.findIndex(
                                (m) => m.serialNo === med.serialNo
                              );
                              copied[idx].discount = e.target.value;
                              copied[idx].billAmount =
                                copied[idx].service.fees *
                                (1 - e.target.value / 100);

                              setsession(copied);
                            }}
                            placeholder="discount in %"
                            sx={{
                              background: "#fff",
                              borderRadius: 1,
                            }}
                          />
                        </TableCell>
                        {/* Amount */}
                        <TableCell>
                          {/* billAmount (Free Text) */}
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type="number"
                            value={med.billAmount || ""}
                            onChange={(e) => {
                              const copied = [...session];
                              const idx = copied.findIndex(
                                (m) => m.serialNo === med.serialNo
                              );
                              copied[idx].billAmount = e.target.value;
                              setsession(copied);
                            }}
                            placeholder="Bill Amount"
                            sx={{
                              background: "#fff",
                              borderRadius: 1,
                            }}
                          />
                        </TableCell>

                        <TableCell align="center">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => {
                              const filtered = session?.filter(
                                (m) => m.serialNo !== med.serialNo
                              );
                              let count = 0;
                              const nextMeds = filtered.map((m) => ({
                                ...m,
                                serialNo: ++count,
                              }));
                              setsession(nextMeds);
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Grid2
              size={12}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "end",
                marginTop: "10px",
              }}
            >
              <Typography fontSize="18px" color="primary">
                Total Amount
              </Typography>
              <Typography fontSize="18px" variant="body1">
                {totalAmount}
              </Typography>
              <Typography fontSize="18px" color="primary">
                Total Discount
              </Typography>
              <Typography fontSize="18px" variant="body1">
                {totalAmount - totalBilledAmount} (
                {totalBilledAmount
                  ? (
                      ((totalAmount - totalBilledAmount) * 100) /
                      totalAmount
                    ).toFixed(2)
                  : 0}{" "}
                in % )
              </Typography>
              <Typography fontSize="18px" color="primary">
                Total Billed Amount
              </Typography>
              <Typography fontSize="18px" variant="body1">
                {totalBilledAmount}
              </Typography>
            </Grid2>
          </Grid2>

          <Grid2 container size={12} spacing={1} padding={"5px 10px"}>
            <Grid2 size={3}>
              <GenericTextField
                label="Advanced Amount"
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(e.target.value)}
                disabled={addingPlan}
                inputSlotProps={{
                  inputLabel: { shrink: true },
                }}
                size="small"
                fullWidth
                placeholder="Enter advanced payment amount"
                type="number"
                inputProps={{ min: 1, max: 1000000 }}
                helperText=""
              />
            </Grid2>
            <Grid2 size={3}>
              <GenericDropDown
                label="Payment Mode"
                margin="dense"
                value={paymentMode || ""}
                onChange={(e) => setPaymentMode(e.target.value)}
                options={PaymentModes}
                required={!!advanceAmount}
                error={!!advanceAmount && !paymentMode}
                name="paymentMode"
                size="small"
                disabled={addingPlan || !advanceAmount}
              />
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default NewPlan;
